/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DirectorStatusDTO = {
    directorNumber?: string;
    name?: string;
    status?: DirectorStatusDTO.status;
};

export namespace DirectorStatusDTO {

    export enum status {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

